import Router from 'next/router';
import trimStart from 'lodash/trimStart';
import config, { DomainType } from './config';
import browser from './browser';
import User from './user';
import { api, cryolite } from './request';
import channel from './channel';
import deepLink from './deep-link';
import qtClient from './qt-client';

const isServer = () => {
  return typeof document === 'undefined';
};

if (!isServer()) {
  document.body.addEventListener('touchstart', () => {});
}

const getUrl = (url, domainType: DomainType = 'api') => {
  if (/^(http(s)?|ws(s)?):/.test(url)) {
    return url;
  }

  url = trimStart(url, '/');
  // return location.protocol + '//' + config.domain[domainType] + '/' + url;
  const domain = config.domain![domainType];
  if (/^(http(s)?|ws(s)?):/.test(domain)) {
    return `${domain}/${url}`;
  }
  return `https://${domain}/${url}`;
};

const getUserUrl = (url) => {
  return getUrl(url, 'user');
};
const getLibUrl = (url) => {
  return getUrl(url, 'lib');
};

const getMainUrl = (url) => {
  return getUrl(url, 'main');
};

const getCurrentUrl = (url) => {
  return `${location.protocol}//${location.host}/${trimStart(url, '/')}`;
};

const getAppUrl = () => {
  const qd = User.getQdInfo().qd;

  let { ckey, pkgname, ios_url } = channel.getConfig()!;

  if (ckey && browser.wechat) {
    pkgname = pkgname || 'com.memezhibo.android';
    return `http://a.app.qq.com/o/simple.jsp?pkgname=${pkgname}&ckey=${ckey}`;
  }
  if (browser.ios) {
    return ios_url || 'https://itunes.apple.com/cn/app/id1450495783?mt=8';
  }
  if (qd === 'MM_h5' || qd === 'MM') {
    return 'http://dl.sumeme.com/app/memezhibo_android_h5.apk';
  }
  return `http://dl.sumeme.com/app/memezhibo_android_${qd.replace(
    /_h5$/gi,
    '',
  )}.apk`;
};

const openDownload = () => {
  deepLink.linkHome();
  // let url = getAppUrl();
  // location.href = url;
};

const redirectRandomStar = () => {
  cryolite.get('api/v2/recomms/promote').then((res: any) => {
    const roomId = res.data.room.id;
    Router.push(`/${roomId}`);
  });
};

let index = 10000;
// 主要用来控制动态弹窗的 层级
const getZIndex = () => {
  index++;
  return index;
};

const openWindow = (url, width = 650, height = 640) => {
  const target = '_blank';
  if (width > 0 && height > 0) {
    // @ts-ignore
    const top =
      (window.screen.availTop || 0) + (window.screen.height - height) / 2;
    // @ts-ignore
    const left =
      (window.screen.availLeft || 0) + (window.screen.width - width) / 2;
    return window.open(
      url,
      'detail',
      `height=${height}, width=${width}, top=${top},left=${left}, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no`,
    );
  }
  return window.open(url, target);
};

const isPcClientPage = () => {
  return window.inPcClient;
};

const redirectUrl = (
  url: string,
  isOpen = false,
  opt: {
    width?: number;
    height?: number;
    isModal?: boolean;
    isClientWebView?: boolean;
  } = {},
) => {
  const {
    width = 1400,
    height = 900,
    isModal = false,
    isClientWebView = false,
  } = opt;
  const isDisableToken = /^(http(s)?|ws(s)?):/.test(url);
  let redirectUrl = getMainUrl(url);

  const [pathUrl, hash = ''] = redirectUrl.split('#');

  if (
    User.getToken() &&
    isPcClientPage() &&
    browser.memeClient &&
    !isDisableToken
  ) {
    redirectUrl = `${
      pathUrl + (redirectUrl.indexOf('?') > -1 ? '&' : '?')
    }access_token=${User.getToken()}${hash ? `#${hash}` : ''}`;
  }

  console.log(
    'redirectUrl',
    redirectUrl,
    isPcClientPage(),
    browser.memeClient,
    isClientWebView,
  );

  if (isOpen) {
    if (isClientWebView) {
      // qtClient.call({
      //   // action: 'openQtWebView',
      //   action: isQtWebView ? 'openQtWebView' : 'openBrowser',
      //   data: {
      //     url: redirectUrl,
      //     width,
      //     height,
      //   },
      //   onSuccess: (msg) => {},
      //   onFail: (msg) => {},
      // });
      window.open(redirectUrl, 'inClient', `width=${width},height=${height}`);
    } else if (isModal) {
      openWindow(redirectUrl);
    } else {
      window.open(redirectUrl);
    }
  } else {
    location.href = redirectUrl;
  }
};

const openUrl = (url) => {
  redirectUrl(url, true);
};

const openRoom = (roomId) => {
  redirectUrl(`/${roomId}`, true);
};

export {
  isServer,
  getUrl,
  getUserUrl,
  getLibUrl,
  getAppUrl,
  getMainUrl,
  getCurrentUrl,
  openDownload,
  redirectRandomStar,
  getZIndex,
  openWindow,
  isPcClientPage,
  redirectUrl,
  openUrl,
  openRoom,
};
